import { render } from "./AIAgentIcon.vue?vue&type=template&id=5a6a5dd4&scoped=true"
import script from "./AIAgentIcon.vue?vue&type=script&lang=js"
export * from "./AIAgentIcon.vue?vue&type=script&lang=js"

import "./AIAgentIcon.vue?vue&type=style&index=0&id=5a6a5dd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a6a5dd4"]])

export default __exports__